import { adminCompaniesEndpoints, adminCompaniesQueryParams } from "@/constants";
import { axiosClient } from "@/services/axios-client";
import { transformApiCompanyHandler } from "@/services/shared";
import type {
    ApiCompanyType,
    ApiPaginatedResponseType,
    CompanyType,
    ListCompaniesFiltersType,
} from "@/types";

export const listCompaniesHandler = async (filters: ListCompaniesFiltersType = {}): Promise<CompanyType[]> => {
    const params: Record<string, number | string> = {};

    if (typeof filters.isEnabled === "boolean") params[adminCompaniesQueryParams.isEnabled] = filters.isEnabled ? 1 : 0;

    if (filters.search) params[adminCompaniesQueryParams.search] = filters.search;

    const response = await axiosClient.get<ApiPaginatedResponseType<ApiCompanyType> | ApiCompanyType[]>(
        adminCompaniesEndpoints.base,
        { params },
    );

    const list = Array.isArray(response.data) ? response.data : response.data.data;

    return list.map(transformApiCompanyHandler);
};
